import { OrganizationId, Organization, OrganizationStub } from '@kaizenplatform/intelligence-entity';
import gql from 'graphql-tag';
import GraphQLClient from '../../adapter/GraphQLClient';
import sleep from '../../utility/sleep';

class OrganizationWebApi {
  private readonly graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public getStubById = async (organizationId: OrganizationId): Promise<Organization> => {
    // await sleep(2000);

    return new OrganizationStub({
      id: organizationId,
    });
  };

  public getById = async (organizationId: OrganizationId): Promise<Organization> => {
    const result = await this.graphqlClient.query(
      gql`
        query getOrganizationById($id: ID!) {
          organization(id: $id) {
            id
            name
            createdAt
          }
        }
      `,
      { id: organizationId },
    );

    if (!result.organization) {
      throw new OrganizationNotFound({ id: organizationId });
    }

    return Organization.fromJSON(result.organization);
  };

  public getStubAllAvailableOrganizations = async (): Promise<Organization[]> => {
    await sleep(2000);

    return [
      new OrganizationStub({
        id: '19035',
        name: 'セブンネットショッピング',
      }),
    ];
  };
}

export class OrganizationNotFound extends Error {
  public readonly name = 'ProjectNotFound';
  public readonly message: string;
  public readonly id: OrganizationId;

  constructor({ id }: { id: OrganizationId }) {
    super();

    this.id = id;
    this.message = `message.fetch_creations_has_failed`;
  }
}

export class OrganizationFetchingFailed extends Error {
  public readonly name = 'OrganizationFetchingFailed';
  public readonly message: string;

  constructor({
    invitationToken,
    status,
    responseBody,
  }: {
    invitationToken: string;
    status: number;
    responseBody: string;
  }) {
    super();

    this.message = `Fetching the organization (invitationToken: ${invitationToken}) is failed. (${status})\n${responseBody}`;
  }
}

export class OrganizationJoiningFailed extends Error {
  public readonly name = 'OrganizationJoiningFailed';
  public readonly message: string;

  constructor({
    invitationToken,
    status,
    responseBody,
  }: {
    invitationToken: string;
    status: number;
    responseBody: string;
  }) {
    super();

    this.message = `Joining into the organization (invitationToken: ${invitationToken}) is failed. (${status})\n${responseBody}`;
  }
}

export default OrganizationWebApi;
